<template>
    <div>
        <modal :name="modal_name" class="final-modal signature-status" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;background:#fff !important;">
                <div class="v-modal-header" style="background:#005dae !important;">
                    <span class="v-modal-dialog-title v-modal-title text-white" style="text-transform:none !important;">{{statusUpdate}} Ticket</span>
                </div>
                <div class="general-section pt-2 pl-0 pr-0 pb-1" style="background-color:#cce3fc;border-radius:0px">
                    <div class="v-modal-body p-0" style="max-height: 410px;overflow-x: hidden;overflow-y: auto;">
                        <div class="d-form" style="overflow: initial !important;">
                            <div class="serviceticket">
                                <div class="fw-600 fs-16 statustext">
                                    <span v-if="loggedInUser.service_ticket_required">
                                        Service
                                    </span>
                                    Ticket {{"#" + closed_ticket.ticket_number}}</div>
                            </div>
                            <div class="serviceticket">
                                <!-- <div class="">
                                    <div class="statushead">Company</div>
                                    <div class="statustext">{{closed_ticket.company || '-'}}</div>
                                </div> -->
                                <div class="mt-2">
                                    <div class="statushead">Subject</div>
                                    <div class="statustext">{{closed_ticket.subject || '-'}}</div>
                                </div>
                                <div class="mt-2">
                                    <div class="statushead">Author Name</div>
                                    <div class="statustext">{{closed_ticket.author_name.hasOwnProperty('name') ? closed_ticket.author_name.name : closed_ticket.author_name || '-'}}</div>
                                </div>
                                <div class="mt-2">
                                    <div class="statushead">Assigned To</div>
                                    <div class="statustext">{{closed_ticket.assigned_to || '-'}}</div>
                                </div>
                            </div>
                            <div class="serviceticket">
                                <div class="">
                                    <div class="statushead">Description</div>
                                    <div class="text-black fw-500 description-content" v-if="closed_ticket.description" v-html="closed_ticket.description"></div>
                                    <div v-else>-</div>
                                </div>
                            </div>
                            <!-- <div class="serviceticket">
                                <div class="">
                                    <div class="statustext">Signature</div>
                                    <div class="mt-4 mb-4 text-center">
                                        <label class="choose-file mt-1">
                                            <input type="file" id="multiple" @change="uploadAttachment" accept=".bmp, .gif, .jpeg, .png, .svg, .tiff/*">
                                            Upload
                                        </label>
                                    </div>
                                    <div class="signaturebg mt-3" v-for="(attach,index) in attachments" :key="index">
                                        <div class="d-flex justify-content-between align-items-center px-2 py-1">
                                            <span class="fs-13 text-dark fw-500">
                                                Customer
                                                <i class="icon icon-check-circle fs-14 text-success"></i>
                                            </span>
                                            <span class="fs-13 text-dark fw-500">{{created_date}}</span>
                                        </div>
                                        <div class="statustext pl-2 fs-13">{{loggedInUser.full_name}}</div>
                                        <div class="text-center m-2 p-2">
                                            <img :src="attach.url" alt="" style="height:50px;width:100px">
                                        </div>
                                        <div v-if="attach.uploading || attach.url == undefined" class="pl-5">
                                            <progress-bar class="progressBar w-80" :class="{'error-upload':attach.url == undefined}" :val="attach.progress" size="small"></progress-bar>
                                        </div>
                                        <div class="d-flex justify-content-between pl-5">
                                            <div class="text-danger pl-0 fw-500" v-if="attach.error != ''">{{attach.error}}...</div>
                                            <div class="text-secondary fw-500" v-if="attach.progress<100 && attach.error == ''">{{attach.progress}}% Uploading</div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                        <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;" @click="hideView()">CANCEL</a>
                        <button type="button" class="btn btn-success btn-smm text-white ml-4" @click="save()" style="box-shadow: none;">
                            SAVE
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import convert from '../mixins/convert.js';
import { EventBus } from '../eventBus/nav-bar-event.js';
import attachment from "../mixins/attachments.js";
import ticket from '../mixins/ticket.js';
import { SweetModal } from 'sweet-modal-vue'
export default {
    props:['modal_name','closed_ticket', 'customer_name'],
    mixins:[convert,attachment,ticket],
    data(){
        return{
            statusUpdate:'',
            attachments:[],
            success_msg:'',
            warning_msg:'',
        }
    },
    components:{
        SweetModal
    },
    methods:{
        hideView(){
            this.attachments = []
            this.$modal.hide(this.modal_name);
            this.$modal.show('status-change');
        },
        save(){
            // if(this.attachments && this.attachments.length){
                let params ={
                    signature: '',
                    // signature:this.attachments[0].url || '',
                    status:'closed',
                    ticket_id:this.closed_ticket.ticket_id
                }
                this.confirmSave(params)
            // }else{
                // this.$toasted.global.error("Signature is Required")
            // }
        },
        async confirmSave(params){
            try {
                let res = await this.changeStatus(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$modal.hide(this.modal_name);
                    this.attachments = []
                    EventBus.$emit('RecallNotification')
                    EventBus.$emit('RecallStatusTabs')
                    this.$emit('updateClosedStatus')
                }, 2000);
            } catch (reason) {
                this.attachments = []
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        distinctAttachments(){
            if(this.attachments && this.attachments.length > 1){
                this.attachments.shift()
            }
        }
    },
    mounted() {
        EventBus.$on('openSiganture',(status) => {
            this.statusUpdate = status.ticketDetails
        });
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        created_date(){
            return this.convert(new Date())
        }
    },
    watch:{
        'attachments'(newValue,oldValue){
            if(newValue){
                this.distinctAttachments()
            }
        }
    },
}
</script>
<style scoped>
.serviceticket{
    background-color: #ecf5ff;
    padding: 10px 15px;
    margin: 10px 0px;
	font-family: 'Poppins', sans-serif !important;
}
.statushead{
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #616161;
}
.statustext{
  font-size: 14px;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: left;
  font-weight: 500 !important;
  color: #005dae;
}
.signaturebg{
    background-color: #ffffff;
    width: 70%;
    border-radius: 5px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.3px #f5a623;
}
.p-description-mail {
    white-space: normal !important;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    color: #4e5764;
    margin-bottom: 30px;
    padding-left: 32px;
}
.p-description-mail {
    overflow-y: visible !important;
    overflow-x: scroll;
}
.w-80{
    width: 80% !important;
}
.description-content{
    line-break: anywhere;
    white-space: pre-wrap;
}
</style>